export const CustomPermissions = {
  profile: "profile",
  account: "account",
  users: "users",
  payment: "payment",
  integrations: "integrations",
  notifications: "notifications"
}
